import { Car, CarFront, Truck, Bus, Settings2, ChevronRight, Check } from "lucide-react";
import { CAR_TYPES, zl } from "@/lib/api";
import { StepHeader, NextButton } from "./StepHeader";

const ICONS = { sedan: Car, suv: CarFront, kombi: Truck, van: Bus };

const CarTabs = ({ car, onChange }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6 rise d1">
    {CAR_TYPES.map(({ id, label }) => {
      const Icon = ICONS[id];
      const on = car === id;
      return (
        <button key={id} data-testid={`car-type-${id}`} onClick={() => onChange(id)}
          className={`card-sel flex items-center justify-center gap-3 py-3 rounded-lg border text-sm ${on ? "border-primary text-primary bg-primary/5" : "border-white/15 text-white/70 bg-black/40"}`}>
          <Icon size={20} strokeWidth={1.5} /> {label}
        </button>
      );
    })}
  </div>
);

const PackageCard = ({ p, car, selected, onSelect }) => (
  <div data-testid={`package-card-${p.id}`} className={`card-sel p-5 rounded-xl border bg-black/50 backdrop-blur flex flex-col ${selected ? "border-primary glow-y" : "border-white/15"}`}>
    <h3 className="font-display text-lg font-semibold">{p.name}</h3>
    <p className="text-xs text-muted-foreground mt-2 min-h-[32px]">{p.description}</p>
    <div className="mt-5 mb-5 flex items-baseline gap-2">
      <span className="text-sm text-white/60">od</span>
      <span data-testid={`package-price-${p.id}`} className="font-display text-3xl font-bold text-primary">{zl(p.prices[car])}</span>
    </div>
    <button data-testid={`package-select-${p.id}`} onClick={onSelect} className={`mt-auto py-2.5 rounded-md text-sm font-bold transition-colors inline-flex items-center justify-center gap-2 ${selected ? "bg-white text-black" : "btn-y"}`}>
      {selected ? <><Check size={16} /> Wybrano</> : "Wybierz"}
    </button>
  </div>
);

export const StepPackage = ({ ctx }) => {
  const { b, update, config, go } = ctx;
  return (
    <section data-testid="step-package">
      <StepHeader onBack={() => go("service")} num={2} title="Wybierz pakiet" sub="Dopasuj usługę do swojego auta." />
      <CarTabs car={b.car} onChange={(car) => update({ car })} />
      <div className="grid md:grid-cols-3 gap-4 rise d2">
        {config.packages.map((p) => (
          <PackageCard key={p.id} p={p} car={b.car} selected={b.packageId === p.id} onSelect={() => update({ packageId: p.id })} />
        ))}
      </div>
      <button data-testid="personalize-package-button" disabled={!b.packageId} onClick={() => go("customize")}
        className="card-sel w-full mt-5 flex items-center gap-4 p-4 rounded-xl border border-primary/60 bg-black/50 text-left disabled:opacity-40 disabled:cursor-not-allowed rise d3">
        <Settings2 className="text-primary" size={26} strokeWidth={1.5} />
        <span className="flex-1">
          <span className="block text-sm font-semibold">Spersonalizuj pakiet</span>
          <span className="block text-xs text-muted-foreground">{b.packageId ? "Dobierz usługi dodatkowe do swoich potrzeb" : "Najpierw wybierz pakiet"}</span>
        </span>
        <ChevronRight className="text-primary" size={20} />
      </button>
      <div className="flex justify-end mt-8">
        <NextButton disabled={!b.packageId} onClick={() => go("term")} />
      </div>
    </section>
  );
};
